"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.create_sign_session = void 0;
const store_1 = require("../../../store");
const api_1 = require("../../api");
/**
 * Create a FaceTec SIGN session for document signing
 * Uses MongoDB-only backend (sky_sign_api)
 * Required for completing document signature workflow
 *
 * NOTE: Backend uses "edit" endpoint for document-specific access (signing/editing)
 */
function create_sign_session(request) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const { userState } = store_1.redux_store.getState();
        const { token } = userState;
        return yield new api_1.API().apiPost({
            baseUrl: (_a = process.env.API_URL) !== null && _a !== void 0 ? _a : "",
            endpoint: "facetec/session/edit",
            content: request,
            authorization: `${token}`,
        });
    });
}
exports.create_sign_session = create_sign_session;
